import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const {
    listing,
    variantPrefix,
    showMainImageOnly,
    showThumbnailsOnly,
    selectedImageIndex,
    onThumbnailClick,
  } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        showMainImageOnly={showMainImageOnly}
        showThumbnailsOnly={showThumbnailsOnly}
        selectedImageIndex={selectedImageIndex}
        onThumbnailClick={onThumbnailClick}
      />
    </section>
  );
};

export default SectionGallery;
